import { Injectable } from '@angular/core';
import { AppPermissions, ModulePermissions, PermissionAction } from '@app/interfaces';

@Injectable({
  providedIn: 'root',
})
export class RolesPermissionsService {
  private permissions: AppPermissions = {};
  private isAdmin = false;

  setPermissions(permissions: AppPermissions | string[], isAdmin: boolean) {
    this.isAdmin = isAdmin;
    this.permissions = Array.isArray(permissions) ? this.convertPermissions(permissions) : permissions;

    localStorage.setItem('permissions', JSON.stringify(this.permissions));
    localStorage.setItem('isAdmin', JSON.stringify(this.isAdmin));
  }

  loadFromStorage() {
    this.permissions = JSON.parse(localStorage.getItem('permissions') || '{}');
    this.isAdmin = JSON.parse(localStorage.getItem('isAdmin') || 'false');
  }

  private convertPermissions(permissions: string[]): AppPermissions {
    const result: AppPermissions = {};

    permissions.forEach((permission) => {
      if (!permission) return;

      const parts = permission.split('-');
      if (parts.length < 2) return;

      const module = parts[parts.length - 1];
      const action: PermissionAction = parts.slice(0, parts.length - 1).join('-') as PermissionAction;

      if (!result[module]) result[module] = {};

      result[module][action] = true;
    });

    return result;
  }

  canRead(module: string): boolean {
    if (this.isAdmin) return true;
    return this.permissions?.[module]?.read === true;
  }

  canReadAny(modules: string[]): boolean {
    if (this.isAdmin) return true;
    return modules.some((module) => this.permissions?.[module]?.read === true);
  }
  can(module: string, action: PermissionAction): boolean {
    if (this.isAdmin) return true;
    return this.permissions?.[module]?.[action] === true;
  }

  getIsAdmin(): boolean {
    return this.isAdmin;
  }
}
